import React from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import ImpersonateEntityButton from '@components/ImpersonateEntityButton'
import PageHeader from '@components/PageHeader'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import type { UserModel } from '@domain-group/realhub-backend-api-types'

import { generateUrls } from '@hooks/useUser'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey: string,
   children: React.ReactNode,
   entityPayload:{
    callbacks: {
      loginAsUser: () => void,
    },
    user: UserModel,
    role: {
      title: string,
    },
   },
}

const PageLayout = (props:PageLayoutProps) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    callbacks: { loginAsUser },
    user,
    role
  } = entityPayload

  const { redirect }: { redirect?: string } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const { usersIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Edit User | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <>
            <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
              <ImpersonateEntityButton
                callbacks={{ loginAsEntity: loginAsUser }}
                entity={user}
                disabled={role.title === 'Admin' || role.title === 'Support'}
                marginRight="medium"
              />
            </ScopedConditionalContent>

            <ScopedConditionalContent
              permittedRoleTitles={['Admin', 'Provider Director', 'Support', 'Brand Administrator']}
            >
              <Button
                // @ts-expect-error TS2322
                as="a"
                buttonStyle="secondaryUtility"
                href={redirect || usersIndexUrl}
                size="medium"
                width="auto"
              >
                Back
              </Button>
            </ScopedConditionalContent>
          </>
        )}
        activeTabBarItemKey={activeTabBarItemKey || 'details'}
        tabBarItems={generateTabBarItems(user)}
        title="Edit User"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
